import { Loader } from 'google-maps';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import Mustache from 'mustache';

const mapOptions = {};
const apiKey = 'AIzaSyClTS0-vEHjCflqByUKsoYG3iTaeoJGqgc';
const loader = new Loader(apiKey, mapOptions);

const cardTemplate = document.querySelector('.js-map-card-template')?.innerHTML;

let mapClusterer = null;
let mapMarkers = [];

const mapTheme = [
  {
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f5f5f5'
      }
    ]
  },
  {
    'elementType': 'labels.icon',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#616161'
      }
    ]
  },
  {
    'elementType': 'labels.text.stroke',
    'stylers': [
      {
        'color': '#f5f5f5'
      }
    ]
  },
  {
    'featureType': 'administrative.land_parcel',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#bdbdbd'
      }
    ]
  },
  {
    'featureType': 'poi',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#eeeeee'
      }
    ]
  },
  {
    'featureType': 'poi',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#757575'
      }
    ]
  },
  {
    'featureType': 'poi.park',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#e5e5e5'
      }
    ]
  },
  {
    'featureType': 'poi.park',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#9e9e9e'
      }
    ]
  },
  {
    'featureType': 'road',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#ffffff'
      }
    ]
  },
  {
    'featureType': 'road.arterial',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#757575'
      }
    ]
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#dadada'
      }
    ]
  },
  {
    'featureType': 'road.highway',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#616161'
      }
    ]
  },
  {
    'featureType': 'road.local',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#9e9e9e'
      }
    ]
  },
  {
    'featureType': 'transit.line',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#e5e5e5'
      }
    ]
  },
  {
    'featureType': 'transit.station',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#eeeeee'
      }
    ]
  },
  {
    'featureType': 'water',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#c9c9c9'
      }
    ]
  },
  {
    'featureType': 'water',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#9e9e9e'
      }
    ]
  }
];

export default class Map {

  constructor() {
    this.google = null;
    this.map = null;
  }

  async loadGoogle() {
    this.google = await loader.load();
  }

  async render(target, locations) {
    if (!locations || !Array.isArray(locations)) {
      return false;
    }
    if (!this.google) {
      await this.loadGoogle();
    }
    if (this.map) {
      this.populateMap(locations);
      return;
    }

    const grayTheme = new this.google.maps.StyledMapType(mapTheme, { name: 'Gray' });
    const map = new this.google.maps.Map(target, {
      //center: { lat: -34.397, lng: 150.644 },
      zoom: 2,
      mapTypeControlOptions: {
        //mapTypeIds: ['Gray'],
        mapTypeIds: [],
      },
    });
    this.map = map;
    map.mapTypes.set('Gray', grayTheme);
    map.setMapTypeId('Gray');

    this.populateMap(locations);
  }

  async populateMap(locations) {

    // If there is markers already in map. Clear them.
    if (mapMarkers.length > 0) {
      mapClusterer.clearMarkers();
      mapMarkers.forEach(function(marker) {
        marker.setMap(null);
      });
    }
    mapMarkers = [];

    const infowindow = new this.google.maps.InfoWindow({
      disableAutoPan: false,
      pixelOffset: new this.google.maps.Size(170, 200),
    });

    this.google.maps.event.addListener(this.map, 'click', function(event) {
      infowindow.close();
    });

    const bounds = new this.google.maps.LatLngBounds();
    let markers = locations.map((location, i) => {
      if (location?.coords?.lat) {
        let marker = new this.google.maps.Marker({
          ... location,
          position: location.coords,
          icon: {
            path: this.google.maps.SymbolPath.CIRCLE,
            scale: 32,
            fillColor: '#007cb0',
            fillOpacity: 1,
            strokeColor: 'transparent'
          },
          className: 'google-map__marker',
          title: location.name,
          content: {
            ... location, // Add location data as whole to use new properties in mustache
            image: location.image,
            logo: location.clientLogo,
            name: location.name,
            poBox: location.poBox,
            mapLink: location.mapLink,
            description: location.description,
            address: location.address,
            url: location.url
          },
        });

        this.google.maps.event.addListener(marker, 'click', function() {
          infowindow.close();
          infowindow.setContent(Mustache.render(cardTemplate, marker.content));
          infowindow.open(this.map, marker);
        });

        bounds.extend(new this.google.maps.LatLng('54.5260', '15.2551')); // Just for centering the map so that europe is located in the middle
        bounds.extend(marker.position);
        return marker;
      }
    }).filter(Boolean);

    mapMarkers = mapMarkers.concat(markers);
    mapClusterer = new MarkerClusterer(this.map, mapMarkers, {
      styles: [{
        width: 64,
        height: 64,
        className: 'google-map__cluster'
      }]
    });
    this.map.fitBounds(bounds);
  }
}
